import { HttpClient } from "@angular/common/http";
import { IAppConfig, APP_CONFIG } from "../../../app.config";
import { Inject, Injectable } from "@angular/core";
import { UserProfile } from "../../models/user-profile";
import { Observable } from "rxjs/Observable";

@Injectable()
export class CommonUserService {
    constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {
    }

    getUserProfile(): Observable<UserProfile> {
        var path = this.config.apiEndpoint + "UserProfile";

        return this.http.get(path).map((response: any) => {
            return <UserProfile>response["returnObject"];
        }).catch(this.handleError);
    }

    private handleError(error: Response) {
        return Observable.throw(error.statusText);
    }
}